export default {
      id: "btn_url-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#btn_url",
      toString: function () {
        return this.url;
      }
    }